import { hsmBackendClient } from './client';
import { IControllerResponse } from './types';

export interface GupshupAppResolution {
  websiteId: string;
  phone: string;
  appId: string;
  appName: string;
}

/**
 * Resolves the Gupshup app for a phone number — the "Verificar" step of the
 * 2-step Gupshup alta. Hits `GET /website/{websiteId}/hsm/gupshup-app?phone=`
 * and returns a preview (`appId`/`appName`) **without** provisioning the line.
 * If the phone does not resolve to a live app the backend answers 422 and this
 * rejects (the caller shows the inline "App no encontrada… Escalá a dev").
 */
export async function getGupshupApp(
  websiteId: string,
  phone: string
): Promise<GupshupAppResolution> {
  const response = await hsmBackendClient.get<
    IControllerResponse<GupshupAppResolution>
  >(`/website/${encodeURIComponent(websiteId)}/hsm/gupshup-app`, {
    params: { phone },
  });

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
